<template>
	<v-row class="mx-1 my-7">
		<slot name="meta" />

		<v-col v-if="contentData.Title" cols="12">
			<h3 class="q-title text-center">{{ contentData.Title }}</h3>
		</v-col>

		<slot name="Cards">
			<div class="columns-wrapper align-stretch" :style="itemsStyle">
				<div v-for="(card, key) in contentData.Cards" :key="key" class="column-item pa-2">
					<q-card :card="card" v-if="!isClickable(card)"></q-card>
					<q-card :card="card" v-else v-on:click="maybeLoadHref(card)" class="clickable"></q-card>
				</div>
			</div>
		</slot>
	</v-row>
</template>

<script>
import QCard from './Elements/Card.vue'
import { CmsGroupViewMixin } from '@/CMS/mixins/CmsGroupMixin'

export default {
    name: 'CardGroup',
	components: {
        QCard,
    },
	mixins: [CmsGroupViewMixin],
    props: {
        contentData: {
            type: Object,
            default: function() {
                return {
                    Cards: [{}],
                    Title: '',
                    NumColumns: 4,
                }
            }
        }
    },
    methods: {
        maybeLoadHref (card) {
            if (card.buttonHref.indexOf('http') > -1) {
                if (card.buttonHref.indexOf('quility.com') > -1) {
                    document.location = card.buttonHref
                } else {
                    window.open(card.buttonHref, '_blank')
                }
            } else {
                this.$router.push(card.buttonHref)
            }
        },
        isClickable (card) {
            if (!card.copyToClipboard && !card.buttonText) {
                if (card.buttonHref != '') {
                    return true
                }
            }
            return false
        },
    },
}
</script>
